import * as yup from 'yup';

export const createSchema = yup.object().shape({
    deviceId: yup.string().required(),
    deviceName: yup.string().required(),
    createdBy: yup.string().required(),
    createdAt: yup.date().required(),
    modifiedBy: yup.string().required(),
    modifiedAt: yup.date().required(),
    unit: yup.string().required()
});

export const updateSchema = createSchema.shape({
    id: yup.number().required()
});